export interface AuthTokenResponseModelo {
	access_token: string;
	expires_in: number;
	refresh_expires_in: number;
	token_type: string;
	scope: string;
}

export interface AuthTokenResponse {
	modelo: AuthTokenResponseModelo;
	codigo: number;
	mensaje: string;
	estado: boolean;
}

export class OtpValidationError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'OtpValidationError';
	}
}

export class TokenExpiredError extends Error {
	constructor(tokenType: string) {
		super(`Token ${tokenType} expirado o no disponible`);
		this.name = 'TokenExpiredError';
	}
}

/**
 * El reto de Cloudflare no se pudo ejecutar en el navegador del socio. No es un
 * rechazo: nadie negó la credencial, solo no se pudo probar que hay un humano.
 * Se distingue de `TokenExpiredError` para que este caso no termine en la
 * pantalla de crédito declinado.
 */
export class TurnstileVerificationError extends Error {
	constructor(reason: string) {
		super(`No se pudo verificar el navegador: ${reason}`);
		this.name = 'TurnstileVerificationError';
	}
}
